'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { css } from 'styled-system/css';
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'accent' | 'outline';
}
export function Badge(t0) {
  const $ = _c(5);
  const {
    children,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  let t2;
  if ($[0] !== variant) {
    const variantStyles = {
      default: css.raw({
        bg: "primary",
        color: "white"
      }),
      accent: css.raw({
        bg: "accent",
        color: "secondary"
      }),
      outline: css.raw({
        bg: "transparent",
        color: "text",
        border: "1px solid",
        borderColor: "text-muted"
      })
    };
    t2 = css({
      display: "inline-flex",
      alignItems: "center",
      px: "2.5",
      py: "0.5",
      fontSize: "xs",
      fontWeight: "500",
      borderRadius: "full",
      fontFamily: "body"
    }, variantStyles[variant]);
    $[0] = variant;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== t2) {
    t3 = <span className={t2}>{children}</span>;
    $[2] = children;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}